import { AuthPageShell } from '@/components/auth/auth-page-shell'
import { SignupPending } from '@/components/auth/signup-pending'
import { getAccessRequestConfig } from '@/constants/signup'

export function SignupPendingPage() {
  const accessRequestConfig = getAccessRequestConfig()
  return (
    <AuthPageShell title={accessRequestConfig.successTitle ?? 'Thanks — you are on the list'}>
      <SignupPending />
    </AuthPageShell>
  )
}
